import React from 'react';
import { FadeIn } from './FadeIn';
import { Pill, Beaker, Coffee } from 'lucide-react';
export function WhyItFailed() {
  const failures = [{
    icon: <Pill className="w-8 h-8" data-id="element-236" />,
    title: 'Pastillas para dormir',
    desc: "Te sedan, pero no te dan sueño reparador (te despiertas con 'resaca' química)."
  }, {
    icon: <Beaker className="w-8 h-8" data-id="element-237" />,
    title: 'Melatonina comercial',
    desc: 'Está mal dosificada y bloquea tus receptores naturales.'
  }, {
    icon: <Coffee className="w-8 h-8" data-id="element-238" />,
    title: "Consejos de 'bebe un té'",
    desc: 'Ignoran el pico de cortisol de las 3 AM que dispara tu ansiedad.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-800" data-id="element-239">
      <div className="max-w-4xl mx-auto" data-id="element-240">
        <FadeIn data-id="element-241">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-242">
            Lo que has intentado hasta ahora ha fallado porque:
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-243">
          {failures.map((item, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-244">
              <div className="flex items-start gap-6 p-6 bg-navy-900 rounded-xl border border-navy-700" data-id="element-245">
                <div className="flex-shrink-0 p-4 bg-navy-800 rounded-lg text-amber-500" data-id="element-246">
                  {item.icon}
                </div>
                <div data-id="element-247">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-248">
                    {item.title}
                  </h3>
                  <p className="text-lavender-200" data-id="element-249">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}